/* ============
 * Mutations for the followUps module
 * ============
 *
 * The mutations that are available on the
 * followUps module.
 */

import types from "./mutation-types";

export default {
  [types.CREATE_FOLLOW_UP](state) {
    state.loading = true;
  },
  [types.CREATE_FOLLOW_UP_SUCCESS](state, response) {
    state.followUp = response;
    state.loading = false;
  },
  [types.CREATE_FOLLOW_UP_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },

  [types.UPDATE_FOLLOW_UP](state) {
    state.loading = true;
  },
  [types.UPDATE_FOLLOW_UP_SUCCESS](state) {
    state.followUpSymptoms = [];
    state.loading = false;
  },
  [types.UPDATE_FOLLOW_UP_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },

  [types.FETCH_FOLLOW_UP_LIST](state) {
    state.loading = true;
    state.resolvedAlertId = '';
  },
  [types.FETCH_FOLLOW_UP_LIST_SUCCESS](state, response) {
    state.followUpList = response.followups;
    state.totalCount = response.followUpCount;
    state.loading = false;
  },
  [types.FETCH_FOLLOW_UP_LIST_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },

  [types.DELETE_FOLLOW_UP](state) {
    state.loading = true;
  },
  [types.DELETE_FOLLOW_UP_SUCCESS](state) {
    state.loading = false;
  },
  [types.DELETE_FOLLOW_UP_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },

  [types.GET_FOLLOW_UP_SYMPTOMS](state) {
    state.loading = true;
  },
  [types.GET_FOLLOW_UP_SYMPTOMS_SUCCESS](state, response) {
    state.followUpSymptoms = response.symptoms;
    state.loading = false;
  },
  [types.GET_FOLLOW_UP_SYMPTOMS_FAIL](state, error) {
    state.loading = false;
    state.error = error;
  },

  [types.RESOLVE_FOLLOW_UP_ALERT](state) {
    state.isResolutionLoading = true;
  },
  [types.RESOLVE_FOLLOW_UP_ALERT_SUCCESS](state, response) {
    state.isResolutionLoading = false;
    state.resolvedAlertId = response.resolved_alert_id;
  },
  [types.RESOLVE_FOLLOW_UP_ALERT_FAIL](state, error) {
    state.isResolutionLoading = false;
    state.resolvedAlertId =  '';
    state.error = error;
  },

  [types.FETCH_RESOLVED_NOTES](state) {
    state.isResolutionLoading = true;
  },
  [types.FETCH_RESOLVED_NOTES_SUCCESS](state, res) {
    state.isResolutionLoading = false;
    state.resolvedNotes = res;
    state.error = '';
  },
  [types.FETCH_RESOLVED_NOTES_FAIL](state, error) {
    state.isResolutionLoading = false;
    state.resolvedNotes = [];
    state.errorMessage = error.error.message;
  }
};
